import { App, Button, Card, Col, Form, Input, Row, Select, Space, } from 'antd';
import React, { useEffect, useState } from 'react'
import { API } from '../../../config/api';
import { GET, PUT } from '../../../utils/apicalls';
import { useNavigate, useParams } from 'react-router-dom';
;
function UpdateCourseModule() {
    const [isLoading, setIsLoading] = useState(false);
    const [courseModuleData, setCourseModuledata] = useState<any>([]);
    const [form] = Form.useForm();
    const [allCourseData, setallCourseData] = useState<any>([]);
    const { notification } = App.useApp();
    const { id } = useParams();
    const navigate = useNavigate();

    const fetchCourseModule = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_COURSE_MODULE_BY_ID + id, {});
            setCourseModuledata(response?.data);
            form.setFieldsValue({
                course_module_Title: response?.data?.course_module_Title || '',
                Course_id: Number(response?.data?.Course_id) || 0,
                course_module_subTitle: response?.data?.course_module_subTitle || '',
                // course_module_image: response?.data?.course_module_image || '',
                course_module_description: response?.data?.course_module_description?.map((desc: string) => ({ description: desc })) || [],

            });

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCourseModule();
    }, []);

    const submitHandler = async (values: any) => {
        try {
            let course_module_description = values.course_module_description.map((item: any) => item.description);


            let obj = {
                course_module_Title: values.course_module_Title,
                Course_id: Number(values.Course_id),
                course_module_subTitle: values.course_module_subTitle,
                course_module_image: "string",
                course_module_description: course_module_description, // This is now an array of strings

            };

            setIsLoading(true);
            const postRequest = await PUT(API.UPDATE_COURSE_MODULE + id, obj);

            if (postRequest) {
                notification.success({ message: " updated successfully!" });
                form.resetFields();
                fetchCourseModule();
                navigate(-1);
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };


    const feacthallCourse = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSES, {});
            setallCourseData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        feacthallCourse();
    }, []);

    return (
        <div>
            <h1 className="text-2xl font-bold mb-4" style={{ textAlign: "center" }}>Update Course Module</h1>
            <Card className="p-4 shadow-md rounded-md">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={submitHandler}
                    className="flex flex-wrap gap-4"
                >
                    <Row gutter={16}>
                        {/* Course Title */}
                        <Col span={8}>
                            <Form.Item
                                label="Course Module Title"
                                name="course_module_Title"
                                rules={[{ required: true, message: 'Please input the course Module title!' }]}
                            >
                                <Input placeholder="Enter course Module title" />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="Course"
                                name="Course_id"
                                rules={[{ required: true, message: 'Please select a Course!' }]}
                            >
                                <Select placeholder="Select a Course">
                                    {allCourseData.map((Course: { id: number; course_title: string }) => (
                                        <Select.Option key={Course.id} value={Course.id}>
                                            {Course.course_title}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="Course Module Subtitle"
                                name="course_module_subTitle"
                                rules={[{ required: true, message: 'Please input the Course Module Subtitle!' }]}
                            >
                                <Input placeholder="Enter Course Module Subtitle" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>



                        {/* Course Duration */}
                        {/* <Col span={8}>
                            <Form.Item
                                label="Course Module Image"
                                name="course_module_image"
                                rules={[{ required: true, message: 'Please input the Course Module Image!' }]}
                            >
                                <Upload {...uploadProps} accept="image/*">
                                    <Button className="w-full">Upload Course Image</Button>
                                </Upload>
                                {fileUrl && (
                                    <img src={fileUrl} alt="Course" style={{ width: "50px", height: "50px" }} />
                                )}
                            </Form.Item>
                        </Col> */}
                        <Col span={8}>
                            <Form.Item
                                label="Course  Module Description"
                                name="course_module_description"
                                rules={[{ required: true, message: 'Please input at least one description!' }]}
                            >
                                <Form.List
                                    name="course_module_description"
                                    initialValue={[]}
                                    rules={[
                                        {
                                            validator: async (_, names) => {
                                                if (!names || names.length < 1) {
                                                    return Promise.reject(new Error('At least one description is required'));
                                                }
                                            },
                                        },
                                    ]}
                                >
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, fieldKey, ...restField }) => (
                                                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'description']}
                                                        rules={[{ required: true, message: 'Please input a description!' }]}
                                                    >
                                                        <Input placeholder="Enter description" />
                                                    </Form.Item>
                                                    <Button onClick={() => remove(name)} icon="-">
                                                        Remove
                                                    </Button>
                                                </Space>
                                            ))}
                                            <Form.Item>
                                                <Button type="dashed" onClick={() => add()} icon="+">
                                                    Add Description
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                            </Form.Item>
                        </Col>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={isLoading}>
                                {isLoading ? 'Updating...' : 'Update Course module'}
                            </Button>
                        </Form.Item>
                    </Row>


                </Form>
            </Card>
        </div>
    );
}


export default UpdateCourseModule
